const STATUS = {
  ACTIVE: "Active",
  INACTIVE: "InActive",
  CONFIRMED: "Confirmed",
  DELETED: "Deleted",
  ZERO: 0,
  ONE: 1,
};
export const getToggleStatus = (state) => {
  if (state === STATUS.ACTIVE) return STATUS.INACTIVE;
  else if (state === STATUS.INACTIVE) return STATUS.ACTIVE;
  else if (state === STATUS.CONFIRMED) return STATUS.DELETED;
  else if (state === STATUS.DELETED) return STATUS.CONFIRMED;
  else if (state === STATUS.ZERO) return STATUS.ONE;
  else if (state === STATUS.ONE) return STATUS.ZERO;
};
export const getStatusInBoolen = (state) => {

  if (state === STATUS.ACTIVE) return true;
  else if (state === STATUS.INACTIVE) return false;
  else if (state === STATUS.CONFIRMED) return true;
  else if (state === STATUS.DELETED) return false;
  else if (state === STATUS.ONE) return false;
  else if (state === STATUS.ZERO) return true;
};
